<template>
  <div class="dashboard" style="margin-top:3%">
    <div class="btn-groupe" style="float:right;margin-right: 1%;">
      <v-btn style="margin-right:4px" @click="selectReviewsPart('12')"
        >Part 1 & 2</v-btn
      >
      <v-btn @click="selectReviewsPart('34')">Part 3 & 4</v-btn>
    </div>
    <h4 style="margin-left: 3%;">{{ title }}</h4>
    <div class="chart-wrapper">
      <Bar
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
      <p style="margin-top:-2%;font-size:small;margin-left:3%">
        Last update : {{ updateTime }}
      </p>
    </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 150,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      campaignData: null,
      nbClosedData: [],
      nbEmployeeNotifData: [],
      nbManagerPropData: [],
      nbEmployeePropData: [],
      title: "",
      updateTime: "",
      perimeters: [],
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
        },
        responsive: true,
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            ticks: {
              stepSize: 1,
              max: 101,
              min: 0,
              callback: function(value) {
                return value + " %";
              },
            },
          },
        },
      },
    };
  },
  mounted: function() {
    this.loadCampaigns();
  },
  methods: {
    loadCampaigns() {
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/campaings/dashboard", {
        method: "get",
        credentials: "include",
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.campaignData = response.data;

          this.getPerimeters();
        });
      this.lastUpdate();
    },

    getPerimeters: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/countries", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          let list = [];
          let data = json.data;
          data.forEach((element) => {
            list.push(element.code);
          });
          this.perimeters = list;
          this.selectReviewsPart("12");
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },

    lastUpdate: function() {
      var today = new Date();
      var date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      if (today.getMinutes() < 10) {
        var minutes = "0" + today.getMinutes();
      } else {
        minutes = today.getMinutes();
      }
      var time = today.getHours() + ":" + minutes;
      this.updateTime = date + " " + time;
    },

    //select the review part chart
    selectReviewsPart: function(part) {
      //initiate chart data first part
      if ("12" === part) {
        this.initiateChartData(part);
        this.title = "Performance Review";
        this.chartData.labels = this.perimeters;
        this.chartData.datasets = [
          {
            label: "Closed",
            backgroundColor: "#10AFA3",
            data: this.nbClosedData,
            scale: "step1",
          },
          {
            label: "At Employee Notification",
            backgroundColor: "#D1E0D7",
            data: this.nbEmployeeNotifData,
            scale: "step1",
          },
          {
            label: "At Manager Proposal",
            backgroundColor: "#FFEEA3",
            data: this.nbManagerPropData,
            scale: "step1",
          },
          {
            label: "At Employee Proposal",
            backgroundColor: "#F8B121",
            data: this.nbEmployeePropData,
            scale: "step1",
          },
        ];
      }
      //initiate chart data second part
      else {
        this.initiateChartData(part);
        this.title = "PDR Objectives Setting";

        this.chartData.datasets = [
          {
            label: "Closed",
            backgroundColor: "#10AFA3",
            data: this.nbClosedData,
            scale: "step1",
          },
          {
            label: "At Employee Notification",
            backgroundColor: "#D1E0D7",
            data: this.nbEmployeeNotifData,
            scale: "step1",
          },
          {
            label: "At Manager Proposal",
            backgroundColor: "#FFEEA3",
            data: this.nbManagerPropData,
            scale: "step1",
          },
          {
            label: "At Employee Proposal",
            backgroundColor: "#F8B121",
            data: this.nbEmployeePropData,
            scale: "step1",
          },
        ];
      }
    },

    initiateChartData: function(part) {
      this.campaignData.forEach((element) => {
        for (let indx = 0; indx < this.perimeters.length; indx++) {
          const el = this.perimeters[indx];
          if (element.country.code === el) {
            this.nbClosedData[indx] = this.calculateNbClosed(element, part);
            this.nbEmployeeNotifData[indx] = this.calculateNbEmployeeNotif(
              element,
              part
            );
            this.nbEmployeePropData[indx] = this.calculateNbEmployeeProp(
              element,
              part
            );
            this.nbManagerPropData[indx] = this.calculateNbManagerProp(
              element,
              part
            );
          }
        }
      });
    },

    calculateNbClosed: function(element, part) {
      if ("12" === part) {
        return (
          ((element.nbReviewsFirstPartClosed +
            element.nbReviewsFirstPartClosedRh) *
            100) /
          element.nbReviews
        );
      } else {
        return (
          ((element.nbReviewsSecondPartClosed +
            element.nbReviewsSecondPartClosedRh) *
            100) /
          element.nbReviews
        );
      }
    },

    calculateNbEmployeeNotif: function(element, part) {
      if ("12" === part) {
        return (element.nbReviewsFirstPartEmpNotif * 100) / element.nbReviews;
      } else {
        return (element.nbReviewsSecondPartEmpNotif * 100) / element.nbReviews;
      }
    },

    calculateNbManagerProp: function(element, part) {
      if ("12" === part) {
        return (
          ((element.nbReviewsFirstPartSlmProp +
            element.nbReviewsFirstPartDlmProp +
            element.nbReviewsFirstPartSlmBack) *
            100) /
          element.nbReviews
        );
      } else {
        return (
          ((element.nbReviewsSecondPartSlmProp +
            element.nbReviewsSecondPartDlmProp +
            element.nbReviewsSecondPartSlmBack) *
            100) /
          element.nbReviews
        );
      }
    },

    calculateNbEmployeeProp: function(element, part) {
      if ("12" === part) {
        return (element.nbReviewsFirstPartEmpProp * 100) / element.nbReviews;
      } else {
        return (element.nbReviewsSecondPartEmpProp * 100) / element.nbReviews;
      }
    },
  },
};
</script>
